import React, { FunctionComponent } from 'react'
import { getAllData } from '../../../utils/data'
import { Geofence } from 'server'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import GeofenceListItem from './GeofenceListItem/GeofenceListItem'
import useQueryListener from '../../../hooks/data/useQueryListener'
import { List } from 'antd'

interface IProps {
  userId: number
}

const GeofenceList: FunctionComponent<any> = (props: IProps) => {
  const { userId } = props

  const client = useFeathersClient()

  const geofenceQuery = {
    user_id: userId,
    active: true
  }
  const {
    data: geofences,
    isLoading: geofencesLoading,
    refetch: refetchGeofences
  } = useQuery({
    queryKey: ['geofence', 'find', geofenceQuery],
    queryFn: () => getAllData(client, 'geofence', geofenceQuery),
    gcTime: 0,
    placeholderData: []
  })

  useQueryListener('geofence', refetchGeofences)

  const renderItem = (geofence: Geofence) => <GeofenceListItem geofence={geofence} />

  return <List dataSource={geofences} loading={geofencesLoading} size={'small'} renderItem={renderItem} />
}

export default GeofenceList
